import Players from './players';
import './players.scss';

export default Players;